import apiClient from '@/utils/apiClient'
import actionsVariante from './variante/actions'
import actionsEnaos from './actions.enaos'
import GetItemListForIndexController from '@/wayfinder/actions/App/Http/Controllers/Item/GetItemListForIndexController'
import GetItemListForSelectController from '@/wayfinder/actions/App/Http/Controllers/Item/GetItemListForSelectController'
import GetItemListForCatalogController from '@/wayfinder/actions/App/Http/Controllers/Item/GetItemListForCatalogController'
import GetItemVariantsForCatalogController from '@/wayfinder/actions/App/Http/Controllers/Item/GetItemVariantsForCatalogController'
import GetItemForCatalogController from '@/wayfinder/actions/App/Http/Controllers/Item/GetItemForCatalogController'
import GetItemByIdController from '@/wayfinder/actions/App/Http/Controllers/Item/GetItemByIdController'
import GetItemWithAllRelationsByIdController from '@/wayfinder/actions/App/Http/Controllers/Item/GetItemWithAllRelationsByIdController'
import GetItemActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/Item/GetItemActivitiesByIdController'
import GetSearchItemListForModalController from '@/wayfinder/actions/App/Http/Controllers/Item/GetSearchItemListForModalController'
import GetItemListForModalController from '@/wayfinder/actions/App/Http/Controllers/Item/GetItemListForModalController'
import GetPackListForModalController from '@/wayfinder/actions/App/Http/Controllers/Item/GetPackListForModalController'
import FetchItemsDossierByDossierIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/FetchItemsDossierByDossierIdController'
import ItemsExportController from '@/wayfinder/actions/App/Http/Controllers/Item/ItemsExportController'
import ItemsImportController from '@/wayfinder/actions/App/Http/Controllers/Item/ItemsImportController'
import RenderCatalogItemsController from '@/wayfinder/actions/App/Http/Controllers/Item/RenderCatalogItemsController'
import ItemStockExportController from '@/wayfinder/actions/App/Http/Controllers/Item/ItemStockExportController'
import CreateItemController from '@/wayfinder/actions/App/Http/Controllers/Item/CreateItemController'
import LinkWikiItemToItemControlleur from '@/wayfinder/actions/App/Http/Controllers/Item/LinkWikiItemToItemControlleur'
import MoveWikiItemToItemControlleur from '@/wayfinder/actions/App/Http/Controllers/Item/MoveWikiItemToItemControlleur'
import DeleteItemController from '@/wayfinder/actions/App/Http/Controllers/Item/DeleteItemController'
import DeleteItemWikiItemController from '@/wayfinder/actions/App/Http/Controllers/Item/DeleteItemWikiItemController'
import UpdateItemStockListControlleur from '@/wayfinder/actions/App/Http/Controllers/Item/UpdateItemStockListControlleur'
import GetItemStockForItemController from '@/wayfinder/actions/App/Http/Controllers/ItemStock/GetItemStockForItemController'
import GetItemLocationSetting from '@/wayfinder/actions/App/Http/Controllers/ItemLocationSetting/GetItemLocationSetting'
import UpdateItemLocationSetting from '@/wayfinder/actions/App/Http/Controllers/ItemLocationSetting/UpdateItemLocationSetting'
import ApplyIndexingItemController from '@/wayfinder/actions/App/Http/Controllers/Item/ApplyIndexingItemController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
import UpdateItemController from '@/wayfinder/actions/App/Http/Controllers/Item/UpdateItemController'

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

function errorSuccessCallback(payload) {
  if (payload.errorCallback) {
    payload.errorCallback()
  }
}

export default {
  ...actionsVariante,
  ...actionsEnaos,

  // region fetch
  async fetchAllItem({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetItemListForIndexController.get())
      .then((response) => {
        commit('setItemList', response.data.items)
        commit('setItemMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchAllItem', reason)
      })
  },

  // Light list (id, name) of every item, for selects
  fetchItemsForSelect: (_context) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemListForSelectController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchItemsForCatalog: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemListForCatalogController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchItemVariantsForCatalog: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetItemVariantsForCatalogController.get({ item: payload.item_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  getItemForCatalog: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemForCatalogController.get({ item: payload.item_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  getItemForExcel: ({ commit }, payload) => {
    let funeralHome = payload?.funeralHome || ''

    if (funeralHome) {
      funeralHome = `/${funeralHome}`
    }

    return apiClient
      .get(`/api/item/get-list${funeralHome}`, {
        params: {
          limit: payload?.limit || 500,
          offset: payload?.offset,
          category: payload?.category,
          supplier: payload?.supplier,
          search: payload?.search
        }
      })
      .then((response) => response.data)
  },

  updateItemForExcel: ({ commit }, payload) => {
    let funeralHome = payload?.funeralHome || ''

    if (funeralHome) {
      funeralHome = `/${funeralHome}`
    }

    return apiClient
      .post(`/api/item/update-list${funeralHome}`, {
        items: payload.items,
        itemsToRemove: payload.itemsToRemove
      })
      .then((response) => response.data)
  },

  getItemForStockEdit: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemByIdController.get({ item: payload.item_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async fetchItemByID({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetItemByIdController.get({ item: payload.id }))
      .then(async (response) => {
        await commit('setItem', response.data.item)
        await commit('setItemMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchItemByID', reason)
      })
  },
  fetchItemWithAllRelationsById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemWithAllRelationsByIdController.get({ item: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async fetchNewItem({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    commit('setItem', null)
    await apiClient
      .route(GetNewModelController.get({ query: { model: 'item' } }))
      .then((response) => {
        commit('setItem', response.data.item)
        commit('setItemMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        await console.error(reason)
      })
  },
  fetchItemActivitiesByItemID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemActivitiesByIdController.get({ item: payload.item_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchItemHistory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/api/item/${payload.item_id}/history/${payload.type}`, {
          params: payload.params,
          signal: payload.signal
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchItemByTerms: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetSearchItemListForModalController.get(), {
          params: {
            term: payload.term,
            specific_funeral_home_id: payload.funeral_home_id,
            page: payload.page,
            per_page: payload.per_page
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchItemByCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemListForModalController.get(), {
          params: {
            category: payload.category ?? '',
            specific_funeral_home_id: payload.funeral_home_id,
            term: payload.term,
            page: payload.page,
            per_page: payload.per_page,
            favorite: payload.favorite || undefined,
            called_context: payload.calledContext || undefined
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async fetchItemForCatalogByID({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemForCatalogController.get({ item: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async fetchPackForInvoice({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetPackListForModalController.get(), {
          params: { specific_funeral_home_id: payload.funeral_home_id }
        })
        .then(async (response) => {
          if (response.status === 200) {
            resolve(response.data.packs)
          }
        })
        .catch(async (reason) => {
          reject(reject)
        })
    })
  },
  async fetchItemsDossierForInvoice({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchItemsDossierByDossierIdController[
            '/api/dossier/{dossier}/item-dossier-for-modal'
          ].get({ dossier: payload.dossier_id }),
          {}
        )
        .then(async (response) => {
          if (response.status === 200) {
            resolve(response.data.items)
          }
        })
        .catch(async (reason) => {
          reject(reject)
        })
    })
  },
  async fetchItemPacks() {
    await apiClient
      .route(
        GetItemListForIndexController.get({ query: { category: 'packs' } })
      )
      .then(async (response) => {
        await console.log('fetchItemPacks', response)
      })
      .catch(async (reason) => {
        await console.error('fetchItemPacks', reason)
      })
  },
  // endregion

  //region export items
  async fetchAllItemsForExport({ commit }, payload) {
    return apiClient
      .route(
        ItemsExportController.post(),
        {
          funeral_home_id: payload.funeral_home_id
        },
        {
          responseType: 'blob'
        }
      )
      .then((response) => {
        payload.callback(
          response.data,
          response.headers.get('exported-filename')
        )
      })
      .catch((reason) => {
        console.error('errors', reason)
        commit('auth/setErrors', reason.response, { root: true })
      })
  },
  //endregion

  //region import items
  async importListItems({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })

    let formData = new FormData()
    formData.append('file', payload.file)
    await apiClient
      .route(ItemsImportController.post(), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(async (response) => {
        if (response.status === 200) {
          if (response.data.errors) {
            commit('setErrorImport', response.data.errors)
            errorSuccessCallback(payload)
          } else if (response.data.items) {
            commit('setItemList', response.data.items)
            commit('setItemMetadata', response.data.metadata)
            processSuccessCallback(payload)
          }
        }
      })
      .catch(async (reason) => {
        await console.error('importListItems', reason)
      })
  },
  //endregion

  //region export items catalog
  exportPDFCatalog: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(RenderCatalogItemsController.get(), { params: payload.data })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async ExportStockItems({ commit }, payload) {
    return apiClient
      .route(
        ItemStockExportController.post(),
        {
          funeral_home_id: payload.funeral_home_id,
          export_type: payload.export_type,
          group_by: payload.group_by,
          start: payload.start,
          end: payload.end
        },
        {
          responseType: 'blob'
        }
      )
      .then((response) => {
        payload.callback(
          response.data,
          response.headers.get('exported-filename')
        )
      })
      .catch((reason) => {
        console.error('errors', reason)
        commit('auth/setErrors', reason.response, { root: true })
      })
  },
  //endregion

  // region store
  storeNewItem({ commit }, payload) {
    let formData = new FormData()
    const { new_master_image_file, ...itemForJson } = payload.item

    formData.append('data', JSON.stringify(itemForJson))

    if (new_master_image_file) {
      formData.append('new_master_image_file', new_master_image_file)
    }

    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateItemController.post(), formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          if (response.status === 201) {
            commit('setItem', response.data.item)
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  linkWikiItemToItem({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          LinkWikiItemToItemControlleur.post({
            item: payload.item_id,
            wiki_item_id: payload.wiki_item_id
          })
        )
        .then((response) => {
          if (response.status === 201) {
            commit('setItem', response.data.item)
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // The former link is moved by the API in a single transaction
  moveWikiItemToItem({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          MoveWikiItemToItemControlleur.post({
            item: payload.item_id,
            wiki_item_id: payload.wiki_item_id
          })
        )
        .then((response) => {
          commit('setItem', response.data.item)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updateItem({ commit }, payload) {
    let formData = new FormData()
    const { new_master_image_file, ...itemForJson } = payload.item

    formData.append('data', JSON.stringify(itemForJson))

    if (new_master_image_file) {
      formData.append('new_master_image_file', new_master_image_file)
    }
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .formRoute(UpdateItemController.put({ item: payload.id }), formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          if (response.status === 201) {
            commit('setItem', response.data.item)
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region delete
  async deleteItemById({ commit }, payload) {
    await apiClient
      .route(DeleteItemController.delete.delete({ item: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          commit('setItemList', response.data.items)
          commit('setItemMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('deleteItemById', reason)
      })
  },
  deleteItemWikiItem({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteItemWikiItemController.delete.delete({
            item: payload.id,
            item_wiki_item: payload.item_wiki_item_id
          })
        )
        .then((response) => {
          commit('setItem', response.data.item)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // endregion

  // region undoDelete
  async undoDeleteItemById({ commit }, payload) {
    await apiClient
      .route(DeleteItemController.undo.get({ id: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          commit('setItemList', response.data.items)
          commit('setItemMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('undoDeleteItemById', reason)
      })
  },
  async undoDeleteItemWikiItemById({ commit }, payload) {
    await apiClient
      .route(
        DeleteItemWikiItemController.undo.get({
          item: payload.id,
          Item_wiki_item_id: payload.item_wiki_item_id
        })
      )
      .then(async (response) => {
        commit('setItem', response.data.item)
      })
      .catch(async (reason) => {
        await console.error('undoDeleteWikiPlaceById', reason)
      })
  },
  // endregion

  // region Item stock
  updateItemStockList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(UpdateItemStockListControlleur.put({ item: payload.item_id }), {
          location: payload.location,
          quantity: payload.quantity,
          purchase_price: payload.purchase_price,
          stock_limit: payload.stock_limit
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  fetchItemStock({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemStockForItemController.get({ item: payload.item_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchItemLocationSetting({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemLocationSetting.get(), {
          params: {
            location_id: payload.location_id,
            item_id: payload.item_id
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateItemLocationSetting({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateItemLocationSetting.put({ itemLocationSetting: payload.id }),
          payload.item_stock_setting
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  applyIndexing({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(ApplyIndexingItemController.post(), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
